<h1 mat-dialog-title>Request access to {{data.name}}</h1>

<mat-dialog-content>
    <p class="intro">You don't have access to the {{data.kind}} <strong>{{data.name}}</strong>. Your request goes to its administrators, who can give you access.</p>

    <label class="label" id="request-role-label">Access level</label>
    <mat-radio-group class="roles" [formControl]="roleControl" aria-labelledby="request-role-label">
        @for (r of roles; track r.role) {
            <mat-radio-button [value]="r.role">
                <span class="role-name">{{r.name}}</span>
                <span class="role-description">{{r.description}}</span>
            </mat-radio-button>
        }
    </mat-radio-group>

    <mat-form-field class="full">
        <mat-label>Message (optional)</mat-label>
        <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="8" placeholder="Why you need access, to help the administrators decide"
            [formControl]="notesControl" [maxlength]="ACCESS_REQUEST_NOTES_MAX" id="request-notes"></textarea>
        <mat-hint align="end">{{notesControl.value.length}}/{{ACCESS_REQUEST_NOTES_MAX}}</mat-hint>
        @if (notesControl.hasError('maxlength')) {
            <mat-error>The message must be {{ACCESS_REQUEST_NOTES_MAX}} characters or fewer</mat-error>
        }
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Cancel</button>
    <button mat-flat-button color="accent" cdkFocusInitial (click)="onConfirm()" [disabled]="!isValid()">Send request</button>
</mat-dialog-actions>
